<script lang="ts">
  export let height: number = 8
</script>

<div style={`height: ${height}px`} />

<style>
  div {
    display: block;
    background-color: rgb(235, 235, 235);
  }
</style>
